<template>
  <div class="quillEditor">
    <quill-editor
      class="editor sr-editor"
      ref="quillEditor"
      :value="value"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
      @change="onEditorChange($event)"
      @input="change($event)"
    >
      <div slot="toolbar">
        <SrBigUpload
          :item="uploadItem"
          style="display: none"
          ref="srbigupload"
          @uploadImgSuccess="uploadSuccess"
        />
      </div>
    </quill-editor>
    <div slot="maxlength" v-if="maxlength > 0" class="maxlength">
      <span>{{ (contentLength - 1 || 0) + "/" + maxlength }}</span>
    </div>
  </div>
</template>
<script>
// import config from "@/settings.js";
import Quill from "quill";
// import quillUpload from "@/components/Upload/upload.vue";
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  //   ['blockquote', 'code-block'],

  //   [{'header': 1}, {'header': 2}],               // custom button values
  //   [{'list': 'ordered'}, {'list': 'bullet'}],
  //   [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["10px", "14px", "18px", "32px"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  //   [{'font': []}],
  [{ align: [] }],

  ["image"],
  ["clean"], // remove formatting button
];
export default {
  inject: ["baseUrl", "imgBaseUrl", "uploadBaseUrl", "uploadRequest"],
  name: "SrEditor",
  components: {
    // quillUpload,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: [String, Number],
    item: {
      type: Object,
    },
    placeholder: {
      type: [Number, String],
      default() {
        return "请输入内容";
      },
    },
    contentT: [Number, String],
    type: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showBtn: {
      type: Boolean,
      default() {
        return false;
      },
    },

    maxlength: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  watch: {
    contentT: {
      handler(val) {
        if (val) {
          this.$set(this, "content", val);
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      uploadItem: {
        limit: 500,
        fileType: "jpg,jpeg,jpe,png",
        target: "editor",
      },
      content: null,
      contentTxt: 0,
      contentLength: 1,
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: (value) => {
                
                if (value) {
                  if (
                    this.maxlength >= 0 &&
                    this.contentLength - 1 <= this.maxlength
                  ) {
                    this.$refs.srbigupload.$children[0].$children[0].$el.click();
                  }
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
          clipboard: {
            // 粘贴版，处理粘贴时候带图片
            matchers: [[Node.ELEMENT_NODE, this.handleCustomMatcher]],
          },
        },
        placeholder: this.placeholder, //提示
        readOnly: this.readyOnly, //是否只读
        theme: "snow", //主题 snow/bubble
        syntax: true, //语法检测
      },
    };
  },
  methods: {
    // 失去焦点
    onEditorBlur(editor) {},

    // 获得焦点
    onEditorFocus(editor) {
      if (this.type == true) {
        editor.enable(false);
      } else {
        editor.enable(true);
      }
    },

    handleCustomMatcher(node, Delta) {
      let ops = [];
      Delta.ops.forEach((op) => {
        if (op.insert && typeof op.insert === "string") {
          // 如果粘贴了图片，这里会是一个对象，所以可以这样处理
          ops.push({
            insert: op.insert,
            attributes:op.attributes
          });
        } else if (
          op.insert &&
          op.insert.image &&
          op.insert.image.indexOf("fileId") !== -1
        ) {
          ops.push({
            insert: op.insert,
            attributes:op.attributes,
          });
        }
      });
      Delta.ops = ops;
      return Delta;
    },
    // 开始
    onEditorReady(editor) {
      // editor.enable(false);
    },
    // 值发生变化
    onEditorChange(editor) {
      this.contentTxt = editor.text;
      this.content = editor.html;
      this.contentLength = editor.quill.getLength();
      if (this.maxlength > 0) {
        editor.quill.deleteText(this.maxlength, 4);
      }
    },
    uploadSuccess(res) {
      let url = this.imgBaseUrl + res.id;
      // 获取富文本组件实例
      let quill = this.$refs.quillEditor.quill;
      // 如果上传成功
      let l = quill.getLength();
      // 获取光标所在位置
      let select = quill.getSelection();
      let length = (select && select.index) || l - 1;
      // 插入图片  res.url为服务器返回的图片地址
      quill.insertEmbed(length, "image", url);
      // 调整光标到最后
      quill.setSelection(length + 1);
    },
    change(value) {
      this.$emit("change", value);
    },
    editorClose() {
      this.$refs.quillEditor.quill.enable(false);
    },
    editorOpen() {
      this.$refs.quillEditor.quill.enable(true);
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.quillEditor.quill.enable(false);
      var Size = Quill.import("attributors/style/size");
      Size.whitelist = ["10px", "14px", "18px", "32px"];
      Quill.register(Size, true);
      if (this.contentT) {
        this.content = this.contentT;
        this.contentTxt = this.contentT;
      }
      setTimeout(() => {
        this.$refs.quillEditor.quill.enable(true);
      }, 1500);
    });
    if (this.item.ref !== undefined) {
      this.item.ref = this.$refs.quillEditor;
      
    }
  },
};
</script>
<style lang="scss">
.quill-upload {
  position: absolute;
  right: 20px;
  line-height: 40px;
}
.ql-editor {
  min-height: 300px;
  max-height: 600px;
}
.editor {
  line-height: normal !important;
  scrollbar-color: transparent transparent;
  　scrollbar-track-color: transparent;
  　-ms-scrollbar-track-color: transparent;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="10px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
.ql-editor.ql-blank::before {
  font-style: normal;
}
.quillEditor {
  position: relative;
  .maxlength {
    position: absolute;
    bottom: -10px;
    right: 4px;
    font-size: 12px;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// packages/SrEditor/SrEditor.vue